import React from 'react';

const getPoweredByUrl = (poweredByHTML: string | undefined, guid: string) => {
  if (!poweredByHTML) {
    return `https://idukki.io/?utm_source=${window?.location?.origin}&utm_medium=widget&utm_campaign=${guid}&utm_id=displaywidgets`;
  }

  if (poweredByHTML.includes('feefo.com') || poweredByHTML.includes('Feefo')) {
    return `https://business.feefo.com/?utm_source=${window?.location?.origin}&utm_medium=widget&utm_campaign=${guid}&utm_id=displaywidgets`;
  }

  if (poweredByHTML.includes('idukki.io') || poweredByHTML.includes('assets.idukki.io')) {
    return `https://idukki.io/?utm_source=${window?.location?.origin}&utm_medium=widget&utm_campaign=${guid}&utm_id=displaywidgets`;
  }

  return `https://idukki.io/?utm_source=${window?.location?.origin}&utm_medium=widget&utm_campaign=${guid}&utm_id=displaywidgets`;
};

export default function PoweredBy(props: any) {
  const { guid, className, onPost, layout } = props;

  const poweredByUrl = getPoweredByUrl(layout?.gallerySettings?.poweredByHTML, guid);

  if (layout && layout.gallerySettings.poweredByHTML) {
    return (
      <idk-div
        onClick={() => window.open(poweredByUrl, '_blank')}
        dangerouslySetInnerHTML={{ __html: layout.gallerySettings.poweredByHTML }}
      ></idk-div>
    );
  }
  return (
    <idk-div
      class={`zid-poweredby zid-bg-white zid-w-max ${
        onPost ? '' : 'zid-p-2 zid-mr-2'
      } zid-rounded zid-flex zid-justify-end zid-cursor-pointer zid-mt-2 ${className}`}
      onClick={() => window.open(poweredByUrl, '_blank')}
    >
      <idk-div class="zid-poweredby zid-flex zid-gap-[4px] zid-items-center zid-text-black zid-text-[15px]">
        <idk-p>Powered by</idk-p>
        <img
          loading="lazy"
          alt="https://idukki.io"
          src={'https://assets.idukki.io/logo.svg'}
          style={{ maxHeight: '16px' }}
        />
      </idk-div>
    </idk-div>
  );
}
